import { createFileRoute } from "@tanstack/react-router";
import { EnFormatPage, buildEnFormatHead } from "@/components/site/en/EnFormatPage";
import { EN_FORMATS } from "@/content/en-formats";

const entry = EN_FORMATS["film-production"];

export const Route = createFileRoute("/en_/film-production")({
  head: () =>
    buildEnFormatHead({
      title: entry.meta.title,
      description: entry.meta.description,
      enPath: entry.enPath,
      svPath: entry.svPath,
    }) as never,
  component: Page,
});

function Page() {
  return <EnFormatPage {...entry.page} />;
}
